import "./third-party/jquery.hoverIntent"
import {$doc} from "./_globals.js";

const CLASS_ATTR = "data-hic"; // hover intent class

function handlerIn(evt) {
  const $el = $(evt.currentTarget);
  $el.addClass($el.attr(CLASS_ATTR));
}

function handlerOut(evt) {
  const $el = $(evt.currentTarget);
  $el.removeClass($el.attr(CLASS_ATTR));
}

$doc.hoverIntent({
  over: handlerIn,
  out: handlerOut,
  selector: `[${CLASS_ATTR}]`,
  timeout: 0
});
